import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';

const paramsSchema = z.object({
  loopId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations')({
  params: paramsSchema,
  beforeLoad: requirePermission('view_loop_visualization'),
});
